/* Material and service interactions. Native scroll and focus remain in charge. */
(() => {
  'use strict';
  const boot = () => {
    const media = matchMedia('(prefers-reduced-motion: reduce)');
    const active = new Set();
    const play = (element, frames, options) => {
      if (media.matches || !element?.animate) return;
      const animation = element.animate(frames, options);
      active.add(animation);
      animation.finished.catch(() => {}).finally(() => active.delete(animation));
    };
    const timing = {duration: 720, easing: 'cubic-bezier(.22,1,.36,1)', fill: 'none'};
    // Only new editorial elements: existing GSAP still owns the homepage and product narrative.
    const observer = new IntersectionObserver(entries => {
      entries.forEach(({target,isIntersecting}) => {
        if (!isIntersecting) return;
        observer.unobserve(target);
        play(target,[{opacity:.3,transform:'translateY(26px)'},{opacity:1,transform:'translateY(0)'}],timing);
      });
    },{threshold:.14});
    document.querySelectorAll('.ae-material-grid figure,.ae-entry-grid article,.award-resource-path,.ae-project-contract li').forEach(el => observer.observe(el));
    document.querySelectorAll('.ae-development-process details').forEach(details => details.addEventListener('toggle',()=>{
      if (!details.open) return;
      const image=document.querySelector('#ref-process-photo');
      play(image,[{opacity:.45,transform:'scale(1.025)'},{opacity:1,transform:'scale(1)'}],{...timing,duration:600});
      const copy=details.querySelector('p');
      play(copy,[{opacity:0,transform:'translateY(8px)'},{opacity:1,transform:'translateY(0)'}],{...timing,duration:400});
    }));
    document.querySelectorAll('.ae-cap-panel').forEach(panel => {
      new MutationObserver(() => {
        if (panel.hidden || getComputedStyle(panel).display==='none') return;
        play(panel,[{opacity:.35,transform:'translateY(14px)'},{opacity:1,transform:'translateY(0)'}],{...timing,duration:520});
      }).observe(panel,{attributes:true,attributeFilter:['hidden']});
    });
    const stop = () => {if(media.matches || document.hidden) active.forEach(a=>a.cancel());};
    media.addEventListener('change',stop);document.addEventListener('visibilitychange',stop);
    addEventListener('pagehide',()=>{observer.disconnect();active.forEach(a=>a.cancel());},{once:true});
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();
})();
